// extracted by mini-css-extract-plugin
export default {"tips":"DeviceSelectModal_tips__PmjmO","red":"DeviceSelectModal_red__QWc15"};